<template>
  <v-card data-qa="rolesassignedlist-card-a41u5b">
    <v-card-title data-qa="rolesassignedlist-card-title-wkpkpf" class="role-card-title" v-text="resource.rolesAssigned" />
    <v-card-subtitle data-qa="rolesassignedlist-card-subtitle-mpbize" v-text="resource.rolesAssignedSubtitle" />
    <v-card-subtitle data-qa="rolesassignedlist-card-subtitle-9h6khp"
      v-if="customerId"
      :class="['text-h6', 'font-weight-black', { 'red--text': hasExceededLimit }]"
      v-text="resource.rolesAssignedText"
    />
    <v-card-text data-qa="rolesassignedlist-card-text-xpaikj">
      <v-data-table
        v-if="customerId"
        :headers="headers"
        :items="listOfSmeRoles"
        hide-default-header
        :page.sync="currentPage"
        :footer-props="{
          'items-per-page-options': [10],
          'disable-items-per-page': true,
        }"
        data-qa="rolesassignedlist-data-table-mu0a63">
        <template v-slot:item.roleName="{ item }">
          <v-row justify="start">
            <v-btn
              text
              plain
              depressed
              @click="$emit('viewPermissions', item)"
              :disabled="!item.enabled"
              data-qa="rolesassignedlist-btn-46lftv">
              <font
                :color="item.enabled ? primaryColor : 'black'"
                class="text-capitalize"
                :class="item.enabled ? 'text-decoration-underline font-weight-bold' : 'black--text'"
              >
                {{ item.roleCode }}
              </font>
            </v-btn>
          </v-row>
        </template>

        <template #footer.prepend>
          <v-spacer />
        </template>

        <!-- Action Buttons -->
        <template v-slot:item.assignedFlag="{ item }">
          <v-row justify="end">
            <v-switch data-qa="rolesassignedlist-switch-31n60g"
              inset
              dense
              v-model="item.enabled"
              :color="primaryColor"
              :disabled="item.disabled"
              @change="onSwitchToggle(item)"
            />
          </v-row>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import '@/styles/pages/roles/roles.scss'
import commonService from '../../service/commonService'
import store from '@/core/store'

export default {
  props: {
    customerId: String
  },
  data () {
    return {
      corporateId: JSON.parse(sessionStorage.getItem('corporateId')),
      maxAssignableRoles: this.$appSettings.defaultConfigurations.smeRoles.maxAssignableRoles,
      currentPage: 1,
      listOfSmeRoles: [],
      originalRoles: [],
      permissions: [],
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  async created () {
    await this.getAssignedRoles()
    // Fetch Permissions for SME Users
    this.permissions = store.getters['profileStore/profileData']?.permissions
  },
  methods: {
    async getAssignedRoles () {
      this.listOfSmeRoles = []
      if (!this.customerId) return

      const response = await commonService.getAssignedUserRoles(this.customerId, this.corporateId)
      if (response && !response.causes) {
        this.listOfSmeRoles = response.dehRoleDetails
          .map((role) => ({ ...role, enabled: role.assignedFlag === 'Y', disabled: this.enableRoleBasedAccess ? !this.permissions?.includes('ASSIGN_PERMISSIONS') : false }))
        this.originalRoles = JSON.parse(JSON.stringify(this.listOfSmeRoles))
        this.currentPage = 1
      }
    },
    onSwitchToggle (role) {
      role.assignedFlag = role.enabled ? 'Y' : 'N'
      this.$emit('rolesChanged',
        {
          listOfSmeRoles: this.listOfSmeRoles,
          hasExceededLimit: this.hasExceededLimit,
          isPristine: !this.isDirty
        }
      )
    }
  },
  computed: {
    totalRolesAssigned () {
      return this.listOfSmeRoles.filter(role => role.assignedFlag === 'Y').length
    },
    hasExceededLimit () {
      return this.totalRolesAssigned > this.maxAssignableRoles
    },
    resource () {
      return {
        rolesAssigned: this.$t('smeRoles.rolesAssigned'),
        rolesAssignedSubtitle: this.$t('smeRoles.rolesAssignedSubtitle'),
        rolesAssignedText: this.$t('smeRoles.rolesAssignedText', { maxLimit: this.maxAssignableRoles, count: this.totalRolesAssigned }),
        noRoles: this.$t('smeRoles.noRoles')
      }
    },
    headers () {
      return [
        { text: 'Roles', value: 'roleName', width: '75%', cellClass: 'role-wrap-text' },
        { text: 'Toggle', value: 'assignedFlag', width: '25%', sortable: false }
      ]
    },
    isDirty () {
      return this.listOfSmeRoles
        .some((role, index) => role.assignedFlag !== this.originalRoles[index].assignedFlag)
    }
  },
  watch: {
    customerId: 'getAssignedRoles'
  }
}
</script>
